/*!
 * Copyright © 2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { ESidePanelContent } from '../../../core/models';
import { WindowResizeService } from '../../../core/services';
import { CloseSidePanel } from '../../../core/store/actions';
import { OpenInsightsPanel } from '../../../core/store/actions/insights-panel.actions';
import { getIsSidePanelOpen, getSidePanelContent } from '../../../core/store/selectors';
import { IAppState } from '../../../core/store/state';

@Component({
  selector: 'fm-overlay-side-panel',
  templateUrl: './overlay-side-panel.component.html',
  styleUrls: ['./overlay-side-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverlaySidePanelComponent implements OnInit, OnDestroy {
  isSidePanelOpened$: Observable<boolean>;
  isMobile$: Observable<boolean>;
  sidePanelContent$: Observable<ESidePanelContent>;

  private readonly _unsubscribe$ = new Subject<void>();

  constructor(
    private readonly _store: Store<IAppState>,
    private readonly _windowResizeService: WindowResizeService
  ) {}

  ngOnInit(): void {
    this.isSidePanelOpened$ = this._store.pipe(select(getIsSidePanelOpen));
    this.isMobile$ = this._windowResizeService.isMobile$;
    this.sidePanelContent$ = this._store.pipe(select(getSidePanelContent));
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  hideSidePanel(): void {
    this._store.dispatch(new OpenInsightsPanel());
    this._store.dispatch(new CloseSidePanel());
  }
}
